module.exports = __webpack_public_path__ + "b213dc57bfa0ff88ca7522139c937acf.gif";